import E404 from '@/views/404'
import Login from '@/views/Login'
import Dashboard from '@/views/Dashboard'
import Layout from '@/views/layout/Layout'
import authority from '@/api/authority'

let userActionList = [];
let arr = authority.getUserActions();
if (null != arr && arr.length > 0) {
    userActionList = arr;
}

// 根目录
const rootPath = '';

// 页面路由
const routes = [

    { path: '/', component: Login, name: 'login', hidden: true },
    {
        path: '/404',
        component: () =>
            import ('@/views/404'),
        hidden: true
    },
    {
        path: '/cardManagement',
        component: Layout,
        children: [{
                path: '',
                name: 'Card Management',
                component: () =>
                    import ('@/views/user/List'),
                meta: { title: 'Card Management', icon: 'table' }
            },
            {
                path: 'detail',
                name: 'Create Net Zero Card',
                component: () =>
                    import ('@/views/user/detail'),
                meta: { title: 'Create Net Zero Card' },
                hidden: true
            },
        ],
    },
    {
        path: '/Operational',
        component: Layout,
        children: [{
                path: '',
                name: 'Data Analytic',
                component: () =>
                    import ('@/views/operational/List'),
                meta: { title: 'Data Analytic', icon: 'table' }
            },
            {
                path: 'detail',
                name: 'History Detail',
                component: () =>
                    import ('@/views/operational/detail'),
                meta: { title: 'History Detail', icon: 'table' },
                hidden: true
            },

        ],
    },
    
    // {
    //     path: '/errorLog',
    //     component: Layout,
    //     children: [{
    //             path: '',
    //             name: 'Error log',
    //             component: () =>
    //                 import ('@/views/errorLog/List'),
    //             meta: { title: 'Error log', icon:'table' }
    //         },
    //     ],
    // },
    {
        path: '/activity',
        component: Layout,
        children: [{
                path: '',
                name: 'Activity Settings',
                component: () =>
                    import ('@/views/activity/list'),
                meta: { title: 'Activity Settings', icon: 'table' }
            },
            {
                path: 'detail',
                name: 'Detail',
                component: () =>
                    import ('@/views/activity/detail'),
                meta: { title: '' },
                hidden: true
            },
        ],
    },
    {
        path: '/Company',
        component: Layout,
        children: [{
                path: '',
                name: 'Enterprise Management',
                component: () =>
                    import ('@/views/company/list'),
                meta: { title: 'Enterprise Management', icon: 'table' }
            },
            {
                path: 'detail',
                name: 'Detail',
                component: () =>
                    import ('@/views/company/detail'),
                meta: { title: 'Enterprise Management Detail' },
                hidden: true
            },
            {
                path: 'add',
                name: 'Add',
                component: () =>
                    import ('@/views/company/detail'),
                meta: { title: 'Add Enterprise Management' },
                hidden: true
            },
            {
                path: 'edit',
                name: 'Edit',
                component: () =>
                    import ('@/views/company/detail'),
                meta: { title: 'Edit Enterprise Management' },
                hidden: true
            },
        ],
    },
    {
        path: '/ActivitySetting',
        component: Layout,
        children: [{
                path: '',
                name: '活动数据统计表',
                component: () =>
                    import ('@/views/setting/list'),
                meta: { title: '活动数据统计表', icon: 'table' }
            },
        ],
    },


].map(route => {
    route.path = rootPath + route.path;
    return route;
});


export default routes;


// WEBPACK FOOTER //
// ./src/routes/index.js